import React from 'react';
import styled from 'styled-components'
import SpecInfoList from "./specInfoList";

const OptionModal = ({ onClose, ref, itemSpec, itemDetailedSpec, checkedList, setCheckedList }) => {

    const onCheckedElement = (checked, item) => {
        if (checked) {
            setCheckedList([...checkedList, item]);
        } else if (!checked) {
            setCheckedList(checkedList.filter(el => el !== item));
        }
    };

    const handleInitCheckBox = () => {
        const checkboxes = document.getElementsByName('spec_info');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        })
        setCheckedList([])
    }

    const handleChangeDisplayArr = (item, result) => {
        const element = document.querySelectorAll(`.spec_option_${item}`);
        element.forEach(v => {
            v.style.display = result
        })
    }

    const handleDisplayOption = () => {
        const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
        const allCheckboxesArr = []
        allCheckboxes.forEach((v,i) => {
            let infoNumber = allCheckboxes[i].id.split('-')[1]
            allCheckboxesArr.push(infoNumber)
        })
        let unCheckedList = allCheckboxesArr.filter((v => !checkedList.includes(v)))

        if (checkedList.length === 0) {
            unCheckedList.forEach(item => {
                handleChangeDisplayArr(item, "inherit")
            })
        } else {
            checkedList.forEach((item => {
                handleChangeDisplayArr(item, "inherit")
            }))
            unCheckedList.forEach(item=> {
                handleChangeDisplayArr(item, "none")
            })
        }
        onClose()
    }

    return (
        <Wrapper ref={ref} className="option_wrap">
            <ContentWrapper className="option_wrap">
                <SpecInfoList specInfo={itemSpec} onClose={onClose} onCheckedElement={onCheckedElement} checkedList={checkedList}/>
                <SpecInfoList specInfo={itemDetailedSpec} onClose={onClose} onCheckedElement={onCheckedElement} checkedList={checkedList}/>
            </ContentWrapper>
            <ButtonWrapper>
                <InitButton onClick={handleInitCheckBox}>초기화</InitButton>
                <SelectButton onClick={handleDisplayOption}>선택하기</SelectButton>
            </ButtonWrapper>
        </Wrapper>
    );
};

export default OptionModal;

const Wrapper = styled.div`
    z-index: 2000;
    position: absolute;
    top: 100px;
    left: 30px;
    width: 400px;
    border: 1px solid #666666;
    border-radius: 4px;
    padding: 20px;
    -webkit-box-shadow: 0 4px 8px rgb(0 0 0 / 8%);
    box-shadow: 0 4px 8px rgb(0 0 0 / 8%);
    background-color: #FFFFFF;

    // 스크롤바 숨기기
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    h3 {
        padding: 10px 0;
    }
    .info_name {
        padding: 10px;
    }
    input[type="checkbox"] {
        appearance: none;
        width: 1.5rem;
        height: 1.5rem;
        border: 1.5px solid #999999;
        background-color: white;
        cursor: pointer;

        &:hover {
            background-color: #418DED;
        }

        &:checked {
            border-color: transparent;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' id='all_check_box' width='20' height='20' viewBox='0 0 20 20'%3E%3Crect id='사각형_167' data-name='사각형 167' width='20' height='20' fill='%23418ded'/%3E%3Cpath id='패스_50' data-name='패스 50' d='M115.241,144.8l-5.677,5.674-3.076-3.076-1.625,1.625,4.7,4.7,7.3-7.3-1.622-1.625Z' transform='translate(-100.863 -138.799)' fill='%23fff'/%3E%3C/svg%3E");
            background-size: 100% 100%;
            background-position: 50%;
            background-repeat: no-repeat;
            background-color: #418DED;
        }
    }
`

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 20px;
`

const InitButton = styled.a`
    border: 1px solid #999999;
    padding: 4px 25px;
    border-radius: 8px;
    background-color: #FFFFFF;
    color: #666666;
    margin-right: 5px;

    &:hover {
        background-color: #F6F6F6;
    }
`

const SelectButton = styled.a`
    border: 1px solid #418DED;
    padding: 4px 25px;
    border-radius: 8px;
    background-color: #418DED;
    color: #fff;

    &:hover {
        background-color: #2D7EE4;
        color: #fff;
    }
`

const ContentWrapper = styled.div`
    height: 450px;
    overflow: scroll;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/optionModal.js